import { createSelector, Selector } from '@ngxs/store';
import { AuthorizationModel, AuthorizationState } from './authorization.state';

export class AuthorizationSelectors {
    @Selector([AuthorizationState])
    static getAuthorization(state: AuthorizationModel) {
        return state;
    }

    @Selector([AuthorizationState])
    static getSocialProviders(state: AuthorizationModel) {
        return state?.socialProviders;
    }

    @Selector([AuthorizationState])
    static isAuthorize(state: AuthorizationModel) {
        return !!state?.sid;
    }

    static getSessionProperty(prop:string) {
        return createSelector([AuthorizationState], (state: AuthorizationModel) => {
            return state?.session[prop] || null;
        });
    }
}
